import React from 'react';
import styled from 'styled-components';

import PhoneScreens from 'static/images/landingMarketPlace/photoLast.webp';
import ConversionIcon from 'static/images/landingMarketPlace/arrow.webp';
import SupportIcon from 'static/images/landingMarketPlace/hand.webp';
import ClockIcon from 'static/images/landingMarketPlace/clock.webp';
import ClientsIcon from 'static/images/landingMarketPlace/pensil.webp';

export const BenefitsSection = () => {
    const benefits = [
        {
            icon: <img src={ConversionIcon} alt='' />,
            text: 'Увеличивает конверсию',
        },
        {
            icon: <img src={SupportIcon} alt='' />,
            text: 'Снижает нагрузку на поддержку',
        },
        {
            icon: <img src={ClockIcon} alt='' />,
            text: 'Работает 24/7',
        },
        {
            icon: <img src={ClientsIcon} alt='' />,
            text: 'Собирает базу клиентов',
        },
    ];

    return (
        <BenefitsWrapper>
            <ContentContainer>
                <LeftColumn>
                    <Title>Ваш персональный торговый ассистент уже ждет!</Title>
                    <PhoneImage
                        src={PhoneScreens}
                        alt='Spodial assistant interface'
                    />
                </LeftColumn>

                <RightColumn>
                    <BenefitsList>
                        {benefits.map((benefit, index) => (
                            <BenefitItem key={index}>
                                <IconWrapper>{benefit.icon}</IconWrapper>
                                <BenefitText>{benefit.text}</BenefitText>
                            </BenefitItem>
                        ))}
                    </BenefitsList>
                </RightColumn>
            </ContentContainer>
        </BenefitsWrapper>
    );
};

const BenefitsWrapper = styled.section`
    padding: 80px 0;
    width: 100%;
`;

const ContentContainer = styled.div`
    max-width: 1160px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    gap: 48px;

    @media (max-width: 992px) {
        flex-direction: column;
    }
`;

const LeftColumn = styled.div`
    flex: 1;

    @media (max-width: 992px) {
        width: 100%;
    }
`;

const Title = styled.h2`
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    color: #1a1a1a;
    margin: 0 0 48px;
    font-family: 'Unbounded';

    @media (max-width: 992px) {
        font-size: 28px;
        text-align: center;
        margin-bottom: 32px;
        br {
            display: none;
        }
    }
`;

const PhoneImage = styled.img`
    width: 100%;
    max-width: 560px;
    height: auto;
    border-radius: 24px;

    @media (max-width: 992px) {
        max-width: 100%;
    }
`;

const RightColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 992px) {
        width: 100%;
    }
`;

const BenefitsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const BenefitItem = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    background: #ffffff;
    padding: 16px 24px;
    border-radius: 30px;
    background: #fff;
    box-shadow: 0px 7px 7.8px 0px rgba(27, 0, 162, 0.13);
    transition: transform 0.2s ease-in-out;

    &:hover {
        transform: translateX(8px);
    }

    @media (max-width: 992px) {
        &:hover {
            transform: translateY(-4px);
        }
    }
`;

const IconWrapper = styled.div`
    width: 80px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

const BenefitText = styled.span`
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

export default BenefitsSection;
